module.exports = __webpack_public_path__ + "img/p15.fc80602a.png";